import httpClient from '../../http/client';
import { backendURL } from '../../lib/config';
import { Network } from '../../models/plans';
import { Router } from '../../models/routers';

/** The DGtek routers: the list as it was before routers had a network. */
export const routersURL = (): string => new URL(
  '/api/v1/public/routers',
  backendURL,
).toString();

/**
 * The router Community Fibre supplies. Asked for by network, the same way
 * its plans are: a Community Fibre sign up is offered that router and not
 * the DGtek one.
 */
export const communityFibreRoutersURL = (): string => new URL(
  '/api/v1/public/routers?network=communityfibre',
  backendURL,
).toString();

/**
 * Where the routers for a network are. The qualification's network is null
 * until an address has been checked, and stays null where no network serves
 * it, so anything but Community Fibre is the DGtek list.
 */
export const routersURLFor = (network?: Network | null): string => (
  network === 'communityfibre' ? communityFibreRoutersURL() : routersURL()
);

export function fetchRouters() {
  return httpClient.get<Router[]>(routersURL());
}

export function fetchCommunityFibreRouters() {
  return httpClient.get<Router[]>(communityFibreRoutersURL());
}
